import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.css"

const baseOptions = {
  create: false,
  allowEmptyOption: true,
}

const singleOptions = {
  controlInput: null,
  plugins: ["input_autogrow"],
}

const multipleOptions = {
  plugins: {
    checkbox_options: {
      checkedClassNames: ["ts-checked"],
      uncheckedClassNames: ["ts-unchecked"],
    },
    remove_button: {
      title: "Entfernen",
    },
    input_autogrow: {},
  },
}

export default class extends Controller {
  connect() {
    const options = this.element.getAttribute("multiple")
      ? multipleOptions
      : singleOptions

    this.tomSelect = new TomSelect(this.element, {
      ...baseOptions,
      ...options,
    })
  }

  disconnect() {
    this.tomSelect.destroy()
  }
}
